<script setup lang="ts">
import type { IColumnDefinition, RowData } from '../types';

defineProps<{
  value: any;
  row: RowData;
  column: IColumnDefinition;
}>();
</script>

<template>
  <div class="d-flex justify-content-center align-items-center h-100">
    <iconify-icon
      v-if="value"
      icon="mdi:lock"
      class="text-danger"
      style="font-size: 1.2em"
      title="Locked"
    />

    <iconify-icon
      v-else
      icon="mdi:lock-open-variant"
      class="text-muted opacity-25"
      style="font-size: 1.2em"
      title="Unlocked"
    />
  </div>
</template>
